function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.handlers = {
      '*': []
    };
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(type, handler) {
      if (!this.handlers[type]) {
        this.handlers[type] = [];
      }

      this.handlers[type].push(handler);
    }
  }, {
    key: "off",
    value: function off(type, handler) {
      if (!this.handlers[type]) return;
      var index = this.handlers[type].indexOf(handler);
      if (index === -1) return;
      this.handlers[type].splice(index, 1);
    }
  }, {
    key: "emit",
    value: function emit(type, event) {
      this.handlers[type] && this.handlers[type].map(function (handler) {
        return handler(event);
      });
      this.handlers['*'].map(function (handler) {
        return handler(type, event);
      });
    }
  }, {
    key: "once",
    value: function once(type, handler) {
      var _this = this;

      var onceHandler = function onceHandler(event) {
        _this.off(type, onceHandler);

        handler(event);
      };

      this.on(type, onceHandler);
    }
  }]);

  return EventEmitter;
}();

export { EventEmitter };
//# sourceMappingURL=event-emitter.esm.js.map
